export class BASE_ADDRESS_LOOSE {
    public street_address_1: string;
    public street_address_2: string;
    public country: string;
    public city: string;
    public state: string;
    public zip: string;
    public county: string;
}